import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/diamonds-logo.png'


const _hoisted_1 = { class: "bg-gray-900" }
const _hoisted_2 = { class: "mx-auto max-w-7xl py-12 px-6 md:flex md:items-center md:justify-between lg:px-8" }
const _hoisted_3 = { class: "flex justify-center space-x-6 md:order-2" }
const _hoisted_4 = { class: "text-gray-400 hover:text-gray-500" }
const _hoisted_5 = { class: "text-center text-xs leading-5 text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 md:order-1 md:mt-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex row justify-center items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-8",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", { class: "leading-5 text-gray-100 ml-2 text-xl" }, "Diamonds")
  ])
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, " © " + _toDisplayString(_unref(currentYear)) + " Diamonds Consulting Group. All rights reserved. ", 1)
        ])
      ]),
      _hoisted_6
    ])
  ]))
}
}

})